import { ArtistInstrumentModelMixedModelNoDates } from "@/types/defs/artistInstrumentMixedModelNoDates";
import { ModelPitchRange } from "@/types/defs/modelPitchRange";
import { toModelPitchRange } from "@/utils/api/toModelPitchRange";
import { isArtistTypeGuard } from "@/utils/artistInstrumentModelMixedModel/is/isArtistTypeGuard";
import { isModelTypeGuard } from "@/utils/artistInstrumentModelMixedModel/is/isModelTypeGuard";
import { getArtistSweetSpotRange } from "@/utils/audio/quality/getArtistSweetSpotRange";

// A voice's target MIDI pitch range. Custom models use their trained range; instruments and mixed models have none (null). Only the artist branch depends on `shouldGetArtistsSweetSpot`: - false: the full curated range (recommendation window, CORE PITCH RANGE display, tracking) - true: the sweet-spot point when designated, else the full range (sent to the AI backend as the pitch-analysis sweetspot)
export const getModelPitchRange = ({
  selectedModel,
  shouldGetArtistsSweetSpot,
}: {
  selectedModel: ArtistInstrumentModelMixedModelNoDates | null;
  shouldGetArtistsSweetSpot: boolean;
}): ModelPitchRange => {
  if (selectedModel === null) {
    return null;
  }
  if (isArtistTypeGuard(selectedModel)) {
    return shouldGetArtistsSweetSpot ?
        getArtistSweetSpotRange(selectedModel)
      : selectedModel.filters.pitchRange.specific;
  }
  if (isModelTypeGuard(selectedModel)) {
    return toModelPitchRange(
      selectedModel.pitchRangeLow,
      selectedModel.pitchRangeHigh
    );
  }
  return null;
};
